import { BUILDING_USAGE } from '@/constants/accessor/api/emergencyInspectionResult/buildingOverview/buildingUsage'

/** 建築物用途　*/
export const buildingUsageOption = [
  { value: BUILDING_USAGE.UNSELECTED, text: '未選択' },
  { value: BUILDING_USAGE.DETACHED_HOUSE, text: '戸建て専用住宅' },
  { value: BUILDING_USAGE.TOWN_HOUSE, text: '長屋住宅' },
  { value: BUILDING_USAGE.APARTMENT, text: '共同住宅' },
  { value: BUILDING_USAGE.STORE_HOUSE, text: '併用住宅' },
  { value: BUILDING_USAGE.STORE, text: '店舗' },
  { value: BUILDING_USAGE.OFFICE, text: '事務所' },
  { value: BUILDING_USAGE.HOTEL, text: '旅館・ホテル' },
  { value: BUILDING_USAGE.PUBLIC_FACILITIES, text: '庁舎等公共施設' },
  { value: BUILDING_USAGE.HOSPITAL, text: '病院・診療所' },
  { value: BUILDING_USAGE.NURSERY_SCHOOL, text: '保育所' },
  { value: BUILDING_USAGE.FACTORY, text: '工場' },
  { value: BUILDING_USAGE.STORAGE, text: '倉庫' },
  { value: BUILDING_USAGE.SCHOOL, text: '学校' },
  { value: BUILDING_USAGE.GYMNASIUM, text: '体育館' },
  { value: BUILDING_USAGE.THEATER, text: '劇場・遊技場等' },
  { value: BUILDING_USAGE.OTHER, text: 'その他' }
] as const
